import RoutesMap from "../../route_control/RouteControl"
import {
    AddMaintenance,
    CorrectiveMaintenanceList,
    PreventiveMaintenanceList,
    JobCardList,
    MaintenanceHierarchy,
    StaffMaintenanceHierarchy,
} from '../../pages/maintenance'

// const JobOrderDetails = lazy(() => import('../../pages/maintenance/JobOrderDetails'))

export const MaintenanceRouteImport = {
    RoutesMap,
    PreventiveMaintenanceList,
    AddMaintenance,
    CorrectiveMaintenanceList,
    JobCardList,
    MaintenanceHierarchy,
    StaffMaintenanceHierarchy,
    // JobOrderDetails
}